/**
 * Study ID is compared and stored verbatim by BE, so input is trimmed at the edge before
 * validation rather than normalised anywhere downstream.
 */
export const normalizeStudyIdInput = (value: string): string => value.trim()
